module.exports = __webpack_public_path__ + "img/status-3.84836eb6.svg";